import { z } from "zod";

export const productPriceSchema = z
  .object({
   
    primary_sales_price: z.union([
      z.string({
        message: "Primary Sales Price is required",
      }),
      z.number({
        message: "Primary Sales Price is required",
      }),
    ]),
    secondary_sales_price: z.union([
      z.string({
        message: "Secondary Sales Price is required",
      }),
      z.number({
        message: "Secondary Sales Price is required",
      }),
    ]),
    direct_sales_price: z.union([
      z.string({
        message: "Direct Sales Price is required",
      }),
      z.number({
        message: "Direct Sales Price is required",
      }),
    ]),

    direct_sales_tax: z.any().nullable().optional(),
    direct_sales_tax_type: z.any().nullable().optional(),
    secondary_sales_tax: z.any().nullable().optional(),
    secondary_sales_tax_type: z.any().nullable().optional(),
    primary_sales_tax: z.any().nullable().optional(),
    primary_sales_tax_type: z.any().nullable().optional(),

  })
  
